/* Shanti Enterprise AG – kleine Ergänzungen für Nordic 1.5.1 (29.09.2026) */
(function () {
  function clamp() {
    document.querySelectorAll('.section-header .collection-description, .collection-banner__desc').forEach(function (d) {
      if (d.dataset.shantiClamp) return;
      d.dataset.shantiClamp = '1';
      d.classList.add('shanti-clamp');
      if (d.scrollHeight > d.clientHeight + 2) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'shanti-readmore';
        b.textContent = 'Mehr lesen';
        b.addEventListener('click', function () {
          var closed = d.classList.toggle('shanti-clamp');
          b.textContent = closed ? 'Mehr lesen' : 'Weniger anzeigen';
        });
        d.after(b);
      } else {
        d.classList.remove('shanti-clamp');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clamp); else clamp();
})();

/* «mit Artikelnummer bestellen»: Suche startet erst nach einer Tipp-Pause von 2,5 s und mit Enter,
   nicht erst beim Verlassen des Feldes. Löst Stefans bestehenden change-Handler aus. (07.10.2026) */
(function () {
  var SEL = '.custom_field_artikelnumber_in';
  function fire(el) {
    if (!el || el.disabled) return;
    if ((el.value || '').trim().length < 3) return;
    if (el.dataset.shantiLast === el.value) return;
    el.dataset.shantiLast = el.value;
    if (window.jQuery) { window.jQuery(el).trigger('change'); } else { el.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches(SEL)) return;
    clearTimeout(el._shantiTimer);
    el._shantiTimer = setTimeout(function () { fire(el); }, 2500);
  });
  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (e.key !== 'Enter' || !el.matches || !el.matches(SEL)) return;
    e.preventDefault();
    clearTimeout(el._shantiTimer);
    el.dataset.shantiLast = '';
    fire(el);
  });
})();

/* Warenkorb mitnehmen (07.10.2026): Link zum aktuellen Warenkorb erzeugen (kopieren oder per E-Mail an sich
   selbst senden) und auf einem anderen Gerät über ?wk=… wieder laden. Positionen inkl. Eigenschaften
   (Artikelnummer-Anfragen) bleiben erhalten. Styles: shanti-151.css Abschnitt 10 */
(function () {
  var PARAM = 'wk';
  function enc(obj) { return btoa(unescape(encodeURIComponent(JSON.stringify(obj)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function dec(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return JSON.parse(decodeURIComponent(escape(atob(s)))); }

  function buildLink() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).map(function (it) {
        var o = { id: it.variant_id, q: it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.p = it.properties;
        return o;
      });
      if (!items.length) return null;
      return location.origin + '/?' + PARAM + '=' + enc({ v: 1, i: items });
    });
  }

  function flash(el, text) {
    var old = el.textContent; el.textContent = text; el.disabled = true;
    setTimeout(function () { el.textContent = old; el.disabled = false; }, 2200);
  }

  function inject() {
    document.querySelectorAll('#CartDrawer-Checkout, button[name="checkout"].cart__checkout-button, .cart__ctas button[name="checkout"]').forEach(function (btn) {
      var host = btn.closest('.cart-drawer__footer, .cart__footer, .cart__ctas') || btn.parentElement;
      if (!host || host.querySelector('.shanti-wk')) return;
      var box = document.createElement('div');
      box.className = 'shanti-wk';
      box.innerHTML = '<p class="shanti-wk__hint">Warenkorb auf einem anderen Gerät weiterbearbeiten?</p>' +
        '<div class="shanti-wk__btns"><button type="button" class="shanti-wk__btn" data-wk="copy">Link kopieren</button>' +
        '<button type="button" class="shanti-wk__btn" data-wk="mail">Per E-Mail senden</button></div>';
      host.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-wk]');
        if (!b) return;
        buildLink().then(function (link) {
          if (!link) { flash(b, 'Warenkorb ist leer'); return; }
          if (b.dataset.wk === 'mail') {
            location.href = 'mailto:?subject=' + encodeURIComponent('Mein Warenkorb bei Shanti Enterprise') +
              '&body=' + encodeURIComponent('Diesen Link auf dem anderen Gerät öffnen, dann ist der Warenkorb wieder da:\n\n' + link + '\n\nDer Link ist unabhängig vom Gerät gültig.');
            return;
          }
          var done = function () { flash(b, 'Link kopiert ✓'); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { window.prompt('Link kopieren:', link); });
          else window.prompt('Link kopieren:', link);
        });
      });
    });
  }

  function load() {
    var code;
    try { code = new URLSearchParams(location.search).get(PARAM); } catch (e) { return; }
    if (!code) return;
    var data;
    try { data = dec(code); } catch (e) { return; }
    if (!data || !data.i || !data.i.length) return;
    var items = data.i.map(function (o) { var it = { id: o.id, quantity: o.q || 1 }; if (o.p) it.properties = o.p; return it; });
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function () { location.replace('/cart'); })
      .catch(function () { location.replace('/cart'); });
  }

  function start() {
    load();
    inject();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(inject, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Warenkorb-Sync für angemeldete Kunden (07.10.2026): Der Warenkorb wird bei jeder Änderung an n8n
   (Webhook shop-cart-sync, Data Table shop_warenkorb_sync) gespeichert und beim Öffnen des Shops auf
   einem anderen Gerät automatisch wiederhergestellt. Regeln: gleicher Stand → nichts; lokal leer → Stand
   vom Server laden; beide gefüllt und noch nie synchronisiert → zusammenführen; sonst gewinnt die neuere
   Änderung. Ein Stand, der älter ist als die letzte Bestellung, gilt als verbraucht.
   window.shantiSync wird in layout/theme.liquid nur für angemeldete Kunden gesetzt. */
(function () {
  var S = window.shantiSync;
  if (!S || !S.cid || !S.sig) return;
  var URL = 'https://shanti.n8n.infinitenet.ch/webhook/shop-cart-sync';
  var KEY = 'shanti_wk_ts_' + S.cid;
  var lastOrder = Number(S.lastOrder) || 0;
  var applying = false, pushTimer = null, syncing = false;

  function api(b) {
    b.cid = S.cid; b.sig = S.sig;
    return fetch(URL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(b) })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }
  function getTs() { try { return parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) { return 0; } }
  function setTs(t) { try { localStorage.setItem(KEY, String(t)); } catch (e) { /* ignore */ } }
  function localItems() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      return (c.items || []).map(function (it) {
        var o = { id: it.variant_id, q: it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.p = it.properties;
        return o;
      });
    });
  }
  function key(i) { var p = i.p ? JSON.stringify(Object.keys(i.p).sort().map(function (k) { return [k, i.p[k]]; })) : ''; return i.id + '|' + p; }
  function fingerprint(items) { return items.map(function (i) { return key(i) + '#' + i.q; }).sort().join(';'); }
  function merge(a, b) {
    var map = {}, out = [];
    a.concat(b).forEach(function (i) {
      var k = key(i);
      if (map[k]) { map[k].q = Math.max(map[k].q, i.q); } else { map[k] = { id: i.id, q: i.q, p: i.p }; out.push(map[k]); }
    });
    return out;
  }

  function refreshUi(count) {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var cd = document.querySelector('cart-drawer');
    var ids = ['cart-icon-bubble'];
    if (cd && cd.getSectionsToRender) ids = cd.getSectionsToRender().map(function (s) { return s.section || s.id; });
    fetch(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (cd && cd.getSectionsToRender) {
          cd.getSectionsToRender().forEach(function (section) {
            var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            var html = sections[section.section || section.id];
            if (el && html && cd.getSectionInnerHTML) el.innerHTML = cd.getSectionInnerHTML(html, section.selector);
          });
          var inner = cd.querySelector('.drawer__inner');
          if (inner) inner.classList.toggle('is-empty', !count);
        } else {
          var b = document.getElementById('cart-icon-bubble');
          if (b && sections['cart-icon-bubble']) { var d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html'); var s = d.querySelector('.shopify-section'); if (s) b.innerHTML = s.innerHTML; }
        }
      }).catch(function () { /* ignore */ });
  }

  function apply(items, ts) {
    applying = true;
    var list = items.map(function (o) { var it = { id: o.id, quantity: o.q || 1 }; if (o.p) it.properties = o.p; return it; });
    return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () {
        if (!list.length) return null;
        return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) });
      })
      .then(function () { setTs(ts); applying = false; refreshUi(list.length); })
      .catch(function () { applying = false; });
  }

  function push() {
    if (applying) return Promise.resolve();
    return localItems().then(function (items) {
      var ts = Date.now();
      return api({ op: 'put', items: items, ts: ts }).then(function (r) { if (r && r.ok) setTs(r.ts || ts); });
    });
  }
  function schedulePush() { if (applying) return; clearTimeout(pushTimer); pushTimer = setTimeout(push, 1200); }

  function sync() {
    if (applying || syncing) return;
    syncing = true;
    Promise.all([api({ op: 'get' }), localItems()]).then(function (res) {
      syncing = false;
      var remote = res[0], local = res[1];
      if (!remote || !remote.ok) return;
      var lts = getTs();
      var rItems = (remote.found && remote.ts > lastOrder) ? (remote.items || []) : [];
      var rTs = remote.found ? remote.ts : 0;
      if (fingerprint(rItems) === fingerprint(local)) { if (rTs > lts) setTs(rTs); return; }
      if (!local.length && rItems.length) { apply(rItems, rTs); return; }                 // Gerät leer → wiederherstellen
      if (!rItems.length && local.length) {
        if (remote.found && rTs > lts && remote.ts > lastOrder) { apply([], rTs); } else { push(); } // anderes Gerät hat geleert / oder lokal ist neuer
        return;
      }
      if (lts === 0) { var m = merge(local, rItems); apply(m, Date.now()).then(push); return; }   // erstes Mal auf diesem Gerät → zusammenführen
      if (rTs > lts) { apply(rItems, rTs); } else { push(); }                                     // neuere Änderung gewinnt
    }).catch(function () { syncing = false; });
  }

  /* Änderungen am Warenkorb erkennen (fetch + XHR) */
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (RX.test(url)) p.then(function () { schedulePush(); }, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (RX.test(String(url))) this.addEventListener('loadend', function () { schedulePush(); });
    return origOpen.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && RX.test(f.action)) setTimeout(push, 800); }, true);

  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
